import { createI18n } from 'vue-i18n';
import Cookies from 'js-cookie';

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Z-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const locale = Cookies.get('locale') || 'is-IS';

const i18n = createI18n({
  legacy: false, // enables Composition API mode
  globalInjection: true,
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'is-IS',
  messages: loadLocaleMessages()
});

export default i18n;
